export default {
  required: "Pole jest wymagane",
  requiredIf: "Pole jest wymagane",
  agreement: "Musisz wyrazić zgodę",
  minLengthNazwa: "Minimum 3 znaki",
  date45Days: "Wydarzenie można zgłosić minimum 45 dni przed jego rozpoczęciem",
  dateAfterDateStart:
    "Data zakończenia musi być taka sama lub późniejsza niż rozpoczęcia",
  email: "Wymagany jest poprawny adres e-mail",
  phone: "Wymagany jest poprawny nr telefonu, np. +48 555 555 555",
  fileSizeMin: "Zbyt mały plik",
  fileSizeMax: "Zbyt duży plik",
  fileType: "Niedozwolony typ pliku",
  rangeLocation:
    "Proszę zaznaczyć więcej niż 1 i maksymalnie 4 województwa. Wydarzenie, w którym biorą udział uczestnicy (będący HCP) z więcej niż czterech województw jest wydarzeniem ogólnokrajowym.",
  zip: "Zły kod pocztowy",
  vatid: "Zły nr NIP",
  krs: "Zły nr KRS",
  locationDateStart: "Wybrana data jest poza datą wydarzenia (krok 2)",
  locationDateEnd: "Wybrana data jest poza datą wydarzenia (krok 2)",
  password: "Hasło nie spełnia wymagań",
  sameAsPassword: "Hasła muszą być takie same",
  isUnique: "Organizacja z tym NIP już istnieje, proszę wyszukać po nazwie",
  url2: "Proszę podać poprawny adres strony"
};
